module.exports = __webpack_public_path__ + "img/Vindome_v2.8b89f5d.svg";